export default {"src":"/education/_next/static/media/arrow-right-half-white.7316a6d7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};